import { BigNumber } from 'bignumber.js';
import { FormattedNumber } from 'react-intl';

interface FormattedCurrencyProps {
  alwaysDisplayCents?: boolean;
  currency?: string;
  narrowSymbol?: boolean;
  value: BigNumber | number | string | null;
  zeroMessage?: React.ReactNode;
}

export function FormattedCurrency({
  alwaysDisplayCents = true,
  currency,
  narrowSymbol = true,
  value,
  zeroMessage
}: FormattedCurrencyProps) {
  const amount = !BigNumber.isBigNumber(value) ? BigNumber(value || 0) : value || 0;

  const displayCents = amount.decimalPlaces() !== 0 || alwaysDisplayCents;

  return amount.eq(0) && zeroMessage ? (
    zeroMessage
  ) : (
    <FormattedNumber
      currency={currency}
      currencyDisplay={narrowSymbol ? 'narrowSymbol' : 'symbol'}
      maximumFractionDigits={displayCents ? 2 : 0}
      minimumFractionDigits={displayCents ? 2 : 0}
      style="currency"
      value={amount.toNumber()}
    />
  );
}
